module.exports = new __parcel__URL__("mid-tom_7.970248d0.mp3").toString();